import moment from "moment"

export const ParsingAmount = (val) => {
    return (
        parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    )
}

export const StartUpperCase = (string) => {
    return (
        string.charAt(0).toUpperCase() + string.slice(1)
    )
}

export const TxtNumber = (e, type) => {
    if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
        return
    }
    return false;
}

export const TINNumber = (e, type) => {
    if (!/[0-9-]/.test(e.key)) {
        e.preventDefault();
        return
    }
    return false;
}

export const TxtLetter = (e, type) => {
    if (!/^[a-zA-Z]*$/g.test(e.key)) {
        e.preventDefault();
        return
    }
    return false;
}

export const TxtLetterSpace = (e, type) => {
    if (!/^[a-zA-Z0-9_ ]*$/g.test(e.key)) {
        e.preventDefault();
        return
    }
    return false;
}

export const TxtEmail = (email) => {
    const regEx = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0,9]{1,3}\.[0,9]{1,3}\])|(([a-zA-Z\0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regEx.test(email);

}

export const timeFormat = (timestamp) => {
    const now = moment();
    const postedTime = moment(timestamp, "YYYY-MM-DD HH:mm:ss");
    const diffMinutes = now.diff(postedTime, "minutes");
    const diffHours = now.diff(postedTime, "hours");
    const diffDays = now.diff(postedTime, "days");
    
    if (diffMinutes < 1) return "Just now";
    if (diffMinutes < 60) return `${diffMinutes} min${diffMinutes > 1 ? "s" : ""} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    if (diffDays === 1) return "Yesterday";
    
    return postedTime.format("MMM D, YYYY");
};

export const GetAverageResult = (average) => {
    if (average <= 70) {
        return 'Lousy'
    }else if (average <= 80) {
        return 'Ordinary'
    }else{
        return 'Heroic'
    }
}

export const GetRandomThreeResult = (array) => {
    return array.sort(() => Math.random() - 0.5).slice(0, 3);                    
};

export const GetPercentageFormat = (value) => {
    return parseFloat(Number.isInteger(value) ? value.toString() : value.toFixed(2));
};

export const ComputePercentage = (value, total) => {
    if (value >= total) return 100;

    const percent = (value / total) * 100;
    const rounded = Math.round(percent * 100) / 100; // round to 2 decimals

    // Remove .00 if whole number
    return parseFloat(Number.isInteger(rounded) ? rounded.toString() : rounded.toFixed(2));
};

export const ComputeDays = async(date_start, date_end) => {
    const start = date_start;
    const end = date_end;

    const startDate = new Date(start);
    const endDate = new Date(end);

    const diff = endDate - startDate;

    let days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return days
}
